import { CommonResourceKey } from '@shared/models/ResourceKeys';
import { IControlDescription } from '@shared/models/profiles/ControlDescription';

const createExternalKeyboardCommand = (
    value: string,
    title: string,
    translationKey?: CommonResourceKey
): IControlDescription => {
    return {
        value,
        title,
        ...(translationKey ? { translationKey } : {}),
        isExternalKeyboard: true,
    };
};

export const ExternalKeyboardControlDescription = [
    createExternalKeyboardCommand('keyboard_backtick', '`'),
    createExternalKeyboardCommand('keyboard_1', '1'),
    createExternalKeyboardCommand('keyboard_2', '2'),
    createExternalKeyboardCommand('keyboard_3', '3'),
    createExternalKeyboardCommand('keyboard_4', '4'),
    createExternalKeyboardCommand('keyboard_5', '5'),
    createExternalKeyboardCommand('keyboard_6', '6'),
    createExternalKeyboardCommand('keyboard_7', '7'),
    createExternalKeyboardCommand('keyboard_8', '8'),
    createExternalKeyboardCommand('keyboard_9', '9'),
    createExternalKeyboardCommand('keyboard_0', '0'),
    createExternalKeyboardCommand('keyboard_minus', '-'),
    createExternalKeyboardCommand('keyboard_equal', '='),
    createExternalKeyboardCommand('keyboard_backspace', 'Backspace', 'common:keys.backspace'),
    createExternalKeyboardCommand('keyboard_delete', 'Delete'),
    createExternalKeyboardCommand('keyboard_tab', 'Tab'),
    createExternalKeyboardCommand('keyboard_q', 'q'),
    createExternalKeyboardCommand('keyboard_w', 'w'),
    createExternalKeyboardCommand('keyboard_e', 'e'),
    createExternalKeyboardCommand('keyboard_r', 'r'),
    createExternalKeyboardCommand('keyboard_t', 't'),
    createExternalKeyboardCommand('keyboard_y', 'y'),
    createExternalKeyboardCommand('keyboard_u', 'u'),
    createExternalKeyboardCommand('keyboard_i', 'i'),
    createExternalKeyboardCommand('keyboard_o', 'o'),
    createExternalKeyboardCommand('keyboard_p', 'p'),
    createExternalKeyboardCommand('keyboard_leftbrace', '['),
    createExternalKeyboardCommand('keyboard_rightbrace', ']'),
    createExternalKeyboardCommand('keyboard_capslock', 'Caps', 'common:keys.caps'),
    createExternalKeyboardCommand('keyboard_a', 'a'),
    createExternalKeyboardCommand('keyboard_s', 's'),
    createExternalKeyboardCommand('keyboard_d', 'd'),
    createExternalKeyboardCommand('keyboard_f', 'f'),
    createExternalKeyboardCommand('keyboard_g', 'g'),
    createExternalKeyboardCommand('keyboard_h', 'h'),
    createExternalKeyboardCommand('keyboard_j', 'j'),
    createExternalKeyboardCommand('keyboard_k', 'k'),
    createExternalKeyboardCommand('keyboard_l', 'l'),
    createExternalKeyboardCommand('keyboard_semicolon', ';'),
    createExternalKeyboardCommand('keyboard_singlequote', "'"),
    createExternalKeyboardCommand('keyboard_enter', 'Enter', 'common:keys.enter'),
    createExternalKeyboardCommand('keyboard_shift', 'Left Shift', 'common:keys.leftShift'),
    createExternalKeyboardCommand('keyboard_z', 'z'),
    createExternalKeyboardCommand('keyboard_x', 'x'),
    createExternalKeyboardCommand('keyboard_c', 'c'),
    createExternalKeyboardCommand('keyboard_v', 'v'),
    createExternalKeyboardCommand('keyboard_b', 'b'),
    createExternalKeyboardCommand('keyboard_n', 'n'),
    createExternalKeyboardCommand('keyboard_m', 'm'),
    createExternalKeyboardCommand('keyboard_comma', ','),
    createExternalKeyboardCommand('keyboard_period', '.'),
    createExternalKeyboardCommand('keyboard_slash', '/'),
    createExternalKeyboardCommand('keyboard_controls', 'Left Ctrl', 'common:keys.leftCtrl'),
    //createExternalKeyboardCommand("fn"),
    //createExternalKeyboardCommand("keyboard_windows", "win"),
    createExternalKeyboardCommand('keyboard_command', 'Command', 'common:keys.command'),
    createExternalKeyboardCommand('keyboard_alt', 'Left Alt', 'common:keys.leftAlt'),
    createExternalKeyboardCommand('keyboard_space', 'Space Bar', 'common:keys.space'),
    createExternalKeyboardCommand('keyboard_left', 'Left Arrow', 'common:keys.left'),
    createExternalKeyboardCommand('keyboard_up', 'Up Arrow'),
    createExternalKeyboardCommand('keyboard_down', 'Down Arrow'),
    createExternalKeyboardCommand('keyboard_right', 'Right Arrow'),
    createExternalKeyboardCommand('keyboard_tilde', '~'),
    createExternalKeyboardCommand('keyboard_at', '@'),
    createExternalKeyboardCommand('keyboard_pound', '#'),
    createExternalKeyboardCommand('keyboard_dollar', '$'),
    createExternalKeyboardCommand('keyboard_percent', '%'),
    createExternalKeyboardCommand('keyboard_caret', '^'),
    createExternalKeyboardCommand('keyboard_ampersand', '&'),
    createExternalKeyboardCommand('keyboard_asterisk', '*'),
    createExternalKeyboardCommand('keyboard_leftparenthesis', '('),
    createExternalKeyboardCommand('keyboard_rightparenthesis', ')'),
    createExternalKeyboardCommand('keyboard_underscore', '_'),
    createExternalKeyboardCommand('keyboard_plus', '+'),
    createExternalKeyboardCommand('keyboard_leftbracket', '{'),
    createExternalKeyboardCommand('keyboard_rightbracket', '}'),
    createExternalKeyboardCommand('keyboard_backslash', '\\'),
    createExternalKeyboardCommand('keyboard_pipe', '|'),
    createExternalKeyboardCommand('keyboard_colon', ':'),
    createExternalKeyboardCommand('keyboard_quote', '"'),
    createExternalKeyboardCommand('keyboard_lessthan', '<'),
    createExternalKeyboardCommand('keyboard_greaterthan', '>'),
    createExternalKeyboardCommand('keyboard_question', '?'),
    createExternalKeyboardCommand('keyboard_escape', 'Escape'),
    createExternalKeyboardCommand('keyboard_f1', 'F1'),
    createExternalKeyboardCommand('keyboard_f2', 'F2'),
    createExternalKeyboardCommand('keyboard_f3', 'F3'),
    createExternalKeyboardCommand('keyboard_f4', 'F4'),
    createExternalKeyboardCommand('keyboard_f5', 'F5'),
    createExternalKeyboardCommand('keyboard_f6', 'F6'),
    createExternalKeyboardCommand('keyboard_f7', 'F7'),
    createExternalKeyboardCommand('keyboard_f8', 'F8'),
    createExternalKeyboardCommand('keyboard_f9', 'F9'),
    createExternalKeyboardCommand('keyboard_f10', 'F10'),
    createExternalKeyboardCommand('keyboard_f11', 'F11'),
    createExternalKeyboardCommand('keyboard_f12', 'F12'),
];
